<template>
  <div class="important-page-c display--flex fd--column">
    <!-- 搜索 -->
    <div
      class="search-form btn-2b5a95"
    >
<div class="l-w" :style="{
        height: $store.state.global.isSearchExtend_1
          ? ''
          : $store.state.global.searchFormHeight_1 + 10 + 'px',
      }">
      <el-form
        label-position="right"
        :class="$store.state.global.isSearchExtend_1 ? '' : 'overflow--hidden'"
				@submit.native.prevent
				:model="searchForm"
      >
        <el-form-item label="职位:">
          <el-input 
						v-model.trim="searchForm.position" 
						@keyup.enter.native="seach"
						clearable />
        </el-form-item>
        <el-form-item label="岗位:">
          <el-select 
						v-model="searchForm.post" 
						@visible-change="visibleType"
						ref="visibleRef"
						@keyup.enter.native="seach"
						clearable>
            <el-option value="管理岗位" ></el-option>
            <el-option value="核心岗位" ></el-option>
            <el-option value="一般岗位"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="属性:">
          <el-select 
						v-model="searchForm.attribute"
						@visible-change="visibleattribute"
						ref="attributeRef"
						@keyup.enter.native="seach"
						clearable>
            <el-option value="决策层"></el-option>
            <el-option value="执行层" ></el-option>
            <el-option value="操作层" ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="级别:">
          <el-input 
						v-model.trim="searchForm.rank" 
						@keyup.enter.native="seach"
						clearable />
        </el-form-item>
      </el-form>
    </div>
      <div class="r-w">

      <el-button
        type="primary"
        icon="el-icon-search"
        @click="seach"
        :loading="!$store.state.global.isEndRequest"
        class="btn-2b5a95"
        >搜索</el-button
      >
			<el-button type="primary" @click="resetQuery">重置</el-button>
      <el-button
        type="primary"
        :icon="
          $store.state.global.isSearchExtend_1
            ? 'el-icon-arrow-up'
            : 'el-icon-arrow-down'
        "
        v-if="$store.state.global.searchExtend_1"
        class="btn-2b5a95"
        @click="onExtendClick('isSearchExtend_1')"
        >{{ $store.state.global.searchExtendText_1 }}</el-button
      >
    </div>

    </div>

    <!-- 按钮操作 -->
    <div
      class="Btn-w eaf4ff-btn"
      v-if="tableRes.buttonlist && tableRes.buttonlist.length"
      :style="{
        height: $store.state.global.isBtnExtend_1
          ? ''
          : $store.state.global.BtnHeight_1 + 10 + 'px',
      }"
    >
      <div
        class="btn-l"
        v-if="tableRes.buttonlist"
        :class="$store.state.global.isBtnExtend_1 ? '' : 'overflow--hidden'"
      >
        <el-button
          v-for="(item, index) in tableRes.buttonlist"
          :key="index"
          type="primary"
          @click="onClickBtn(item.buttonname)"
          >{{ item.name }}
        </el-button>
      </div>
      <div class="Btn-extend">
        <el-button
          type="primary"
          v-if="$store.state.global.btnExtend_1"
          class="btn-2b5a95"
          :icon="
            $store.state.global.isBtnExtend_1
              ? 'el-icon-arrow-up'
              : 'el-icon-arrow-down'
          "
          @click="onExtendClick('isBtnExtend_1')"
          >{{ $store.state.global.BtnExtendText_1 }}</el-button
        >
      </div>
    </div>

    <!-- 表格 -->
    <el-table
      :data="tableRes.list"
      stripe
			border
			:header-cell-style="{ background: '#044d8c', color: '#fff'}"
      ref="multipleTable"
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55" align="center" />
      <el-table-column label="职位" prop="position" align="center" />
      <el-table-column label="岗位" prop="post" align="center" />
      <el-table-column label="基本工资" prop="basepay" align="center" />
      <el-table-column label="级别" prop="rank" align="center" />
      <el-table-column label="级别系数" prop="rankcoefficient" align="center" />
      <el-table-column label="属性" prop="attribute" align="center" />
    </el-table>

    <!-- 分页 -->
    <el-pagination
      background
      @current-change="handleCurrentChange"
      :current-page="pageinfo.pageindex"
      :page-size="pageinfo.pagesize"
      :page-sizes="[10, 20, 30, 40, 50]"
      layout="total, prev, pager, next, jumper"
      :total="tableRes.totalcount"
    ></el-pagination>

    <!--添加，修改-->
    <el-dialog
      class="btn-2b5a95"
      width="35%"
      title="添加："
			v-dialogDrag
			:close-on-click-modal='false'
      :visible.sync="showAddModal"
      v-if="showAddModal"
      append-to-body
    >
      <el-form
        :model="dynamicValidateForm"
        ref="dynamicValidateForm"
        :rules="rules"
        class="form-item-w-100"
      >
        <el-form-item label="岗位:" prop="post">
          <el-select v-model="dynamicValidateForm.post">
            <el-option value="管理岗位"></el-option>
            <el-option value="核心岗位"></el-option>
            <el-option value="一般岗位"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="属性:" prop="attribute">
          <el-select v-model="dynamicValidateForm.attribute">
            <el-option value="决策层"></el-option>
            <el-option value="执行层"></el-option>
            <el-option value="操作层"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="职位:" prop="position">
          <el-input v-model.trim="dynamicValidateForm.position" clearable/>
        </el-form-item>
        <el-form-item label="基本工资:" prop="basepay">
          <el-input v-model.trim="dynamicValidateForm.basepay" clearable/>
        </el-form-item>
        <el-form-item label="级别:" prop="rank">
          <el-input v-model.trim="dynamicValidateForm.rank" clearable/>
        </el-form-item>
        <el-form-item label="级别系数:" prop="rankcoefficient">
          <el-input v-model.trim="dynamicValidateForm.rankcoefficient" clearable/>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="submitAddOrEditForm('dynamicValidateForm')"
          :loading="!$store.state.global.isEndRequest"
          >提交
        </el-button>
      </span>
    </el-dialog>

    <!-- 导入 -->
    <Import
      :importDialog="importDialog"
      :importSaveUrl="importSaveUrl"
      @onCloseImport="onCloseImport"
      @getDataList="getDataList"
    ></Import>
  </div>
</template>

<script>
import { mapActions } from "vuex";

import { part } from "@/utils/mixins";
import Import from "@/components/Import/index.vue";
import {
  wages_list,
  wages_input,
  wages_save,
  wages_delete,
  wages_importsave,
} from "@/request/api/allChildrenProject";
import { myRequest } from "@/request/index";
import {
  selectCheck,
  confirmCallBack,
  messageTip,
  createObjParams,
  formatDare,
} from "@/utils/util";

export default {
  mixins: [part],
  name: "wages",
  components: { Import },
  props: {
    importSaveUrl: {
      default: () => wages_importsave,
    },
  },
  data() {
    return {
      // pulic
      itemId: null, //首表格项id
      tableRes: {}, //列表接口
      pageinfo: {
        pageindex: 1,
        pagesize: 10,
      }, //页数查询
      multipleSelection: [], //选中的表格项
      searchForm: {},
      // 增加修改
      dynamicValidateForm: {}, // 对象
      showAddModal: false, //显示表单框
      importDialog: false, //导入框
      // 规则校验
      rules: {
        post: [{ required: true, message: "必填字段", trigger: "change" }],
        attribute: [{ required: true, message: "必填字段", trigger: "change" }],
        position: [{ required: true, message: "必填字段", trigger: "change" }],
        basepay: [{ required: true, message: "必填字段", trigger: "change" }],
        rank: [{ required: true, message: "必填字段", trigger: "change" }],
        rankcoefficient: [
          { required: true, message: "必填字段", trigger: "change" },
        ],
      },
    };
  },
  created() {
    // 获取列表
    this.getDataList();
		window.addEventListener("keyup", this.enterSelect);
  },
  methods: {
    ...mapActions("global", ["onExtendClick"]), //关闭导入框
		reset() {
			this.searchForm = {
				position: null,
				post: null,
				attribute: null,
				rank: null,
			}
		},
		resetQuery() {
			this.reset();
			this.getDataList();
		},
		enterSelect(e) {
			if(e.keyCode == 13) {
				this.getDataList();
			}
		},
		visibleType(e) {
			if(!e) {
				this.$refs.visibleRef.blur();
			}
		},
		visibleattribute(e) {
			if(!e) {
				this.$refs.attributeRef.blur();
			}
		},
    onCloseImport(bool) {
      this.importDialog = bool;
    },
    //导入 click
    btnImport() {
      this.importDialog = true;
    },
    //搜索 click
    seach() {
      this.pageinfo.pageindex = 1;
      this.getDataList();
    },
    //列表查询 api
    getDataList() {
      myRequest({
        url: wages_list,
        data: Object.assign(this.searchForm, this.pageinfo),
      }).then((res) => {
        if (res.data.code === "200") {
          this.tableRes = res.data.data;
        }
      });
    },
    //切换当前页
    handleCurrentChange(val) {
      this.pageinfo.pageindex = val;
      this.getDataList();
    },
    //触发所有btn方法
    onClickBtn(methodsName) {
      this.$options.methods[methodsName].call(this); //btnAdd ... （防止修改this指向）
    },
    //添加click
    btnAdd() {
      this.dynamicValidateForm = {};
      this.showAddModal = true;
    },
    //修改click
    btnEdit() {
      selectCheck(this.multipleSelection, "修改", false, () => {
        this.editRoutePage(this.multipleSelection[0].id);
      });
    },

    //修改路由页 api
    editRoutePage(id) {
      myRequest({
        url: wages_input,
        data: {
          id: id,
        },
      }).then((res) => {
        if (res.data.code === "200") {
          this.showAddModal = true;
          this.dynamicValidateForm = res.data.data.vwages;
          delete this.dynamicValidateForm.inserttime; //inserttime 该字段不用传
          delete this.dynamicValidateForm.isoktime; //isoktime 该字段不用传
        }
      });
    },
    //提交-（添加，修改） api
    submitAddOrEditForm(dynamicValidateForm) {
      this.$refs[dynamicValidateForm].validate((valid) => {
        if (valid) {
          myRequest(
            {
              url: wages_save,
              data: this.dynamicValidateForm,
            },
            {
              isRefTableList: true,
              that: this,
              modal:'showAddModal'
            }
          )
        } 
      });
    },

    //删除click
    btnDel() {
      selectCheck(this.multipleSelection, "删除", true, () => {
        confirmCallBack({
          title: "提示",
          content: "此操作将永久删除选中的数据！",
          success: () => {
            this.delTableItem(this.multipleSelection.map((i) => i.id));
          },
          fail: () => {
            messageTip({
              message: "取消操作",
              type: "info",
            });
          },
        });
      });
    },

    //删除 api
    delTableItem(idArr) {
      myRequest(
        {
          method: "post",
          url: wages_delete,
          data: this.$qs.stringify(
            {
              ids: idArr,
            },
            {
              arrayFormat: "repeat",
            }
          ),
        },
        {
          isRefTableList: true,
          that: this,
        }
      );
    },

    //选中表格数据改变时
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    //刷新 click
    btnReload() {
      this.getDataList();
    },
  },
};
</script>

<style  lang="scss">
</style>